<div class="relative p-6 bg-white z-1 dark:bg-gray-900 sm:p-0">
  <div
    class="relative flex flex-col justify-center w-full h-screen lg:flex-row dark:bg-gray-900 sm:p-0"
  >
    <ng-content></ng-content>
    <div
      class="items-center hidden w-full h-full lg:w-1/2 bg-gradient-to-r from-[#3859FF] via-[#5C77FF] to-[#83B1FF] dark:bg-white/5 lg:grid relative"
    >
      <div class="p-10 z-1">
        <!-- ===== Common Grid Shape Start ===== -->
        <app-grid-shape />
        <div>
          <h3 class="mb-5 font-semibold text-gray-200 text-title-sm text-start dark:text-white/90">
            Your Intelligent Abuse Detection and Domain Trust Management Tool.
          </h3>
          <p class="mb-12 text-gray-200 text-start dark:text-white/60">
            Manage, classify, and resolve domain abuse cases in one place.
          </p>
          <img class="mx-auto" src="/images/login/sign-in-potrait.png" alt="Logo"/>
        </div>
      </div>
    </div>
    <div class="fixed z-50 hidden bottom-6 right-6 sm:block">
      <app-theme-toggle-two />
    </div>
  </div>
</div>
